import React from "react";
import { useSelector } from 'react-redux';

import { Calendar } from "primereact/calendar";
import { checkPermissions } from '../utils';
import PermDetailsWrapper from "../common/PermDetailsWrapper";


function CalendarField(props) {
    const userDetails = useSelector(state => state.userDetails)

    const labelText = props.labelText ? props.labelText : ""
    const placeholder = props.placeholder ? props.placeholder : ""
    const value = props.value ? props.value : ""
    const showIcon = props.showIcon ? props.showIcon : false
    const dateFormat = props.dateFormat ? props.dateFormat : "dd/mm/y"
    const showTime = props.showTime ? props.showTime : false
    const minDate = props.minDate ? props.minDate : ""
    const maxDate = props.maxDate ? props.maxDate : ""
    const hourFormat = props.hourFormat ? props.hourFormat : ""

    const handleOnChange = (e) => {
        if(props.onChange){
            const offsetInMilliseconds = 5.5 * 60 * 60 * 1000
            if (e.value) {
                const newTimezoneDate = new Date(e.value.toLocaleDateString('en-IN', { timeZone: 'Asia/Kolkata' }));
                if (!showTime) {
                    e.value = e.value.setTime(e.value.getTime() + offsetInMilliseconds);
                } else {
                    e.value = e.value
                }
            }else{
                e.value = e.value
            }
            // const newTimezoneDate = new Date (e.value.toLocaleDateString('en-IN', {timeZone: 'Asia/Kolkata'}));
            // if (!showTime){
            //     e.value = e.value.setTime(e.value.getTime() + offsetInMilliseconds);
            // }else{
            //     e.value = e.value
            // }
            // let utcDate = e.value
            // const year = utcDate.getFullYear();
            // const month = utcDate.getMonth();
            // const day = utcDate.getDate();
            // const hours = utcDate.getHours();
            // const minutes = utcDate.getMinutes();
            // const seconds = utcDate.getSeconds();
            // const milliseconds = utcDate.getMilliseconds();

            // // Convert the UTC date to IST by adjusting it with the UTC offset for IST
            // const istOffset = 5.5 * 60 * 60 * 1000; // Offset for IST (UTC+5 hours and 30 minutes)
            // const istTime = utcDate.getTime() + istOffset;

            // // Create a new Date object with the adjusted time
            // const istDate = new Date(istTime);

            // // Set the year, month, and day components to match the original date
            // istDate.setFullYear(year);
            // istDate.setMonth(month);
            // istDate.setDate(day);

            // e.value = istDate
            // console.log("eeee", e)
            props.onChange(e)
        }
    }

    const permissions = props.permissions ? props.permissions : []
    const permParameters = props.permParameters ? props.permParameters : {}

    let disabled = false 
    let isPermitted = false
    let permittedCompanyRoleIds = []
    let permittedExceptionUserRoleIds = []
    let permittedExceptionNegitiveUserRoleIds = []

    if(permissions.length){
        // console.log("permissions input", permissions)
        const permParams = {
            reqPermActionIds: permissions,
            permParameters: permParameters,
            activeCompanyRoleId: userDetails.activeCompanyRoleId,
            userRoleId: userDetails.activeRoleId,
            permExceptions: userDetails.permExceptions,
            permGeo: userDetails.permGeo,
            permActions: userDetails.permActions,
            permRoles: userDetails.permRoles,
            companyRoles: userDetails.companyDetails.companyRoles
        }

        const permissionDetails = checkPermissions(permParams)
        isPermitted = permissionDetails.isPermitted
        permittedCompanyRoleIds = permissionDetails.permittedCompanyRoleIds
        permittedExceptionUserRoleIds = permissionDetails.permittedExceptionUserRoleIds
        permittedExceptionNegitiveUserRoleIds = permissionDetails.permittedExceptionNegitiveUserRoleIds

        if(!isPermitted){
            disabled = true
        }
    }

    if(props.disabled){
        disabled = true
    }

    const renderCalenderField = () => (
        <>
            {
                labelText ? 
                    <label htmlFor="calendar-12h" className=" block text-xs" style={{fontSize: '12px', marginBottom: '3px'}} >{labelText}{ props.required && <span style={{color:"red"}} className="from-required">*</span> }</label> 
                    : ""
            }
            <Calendar 
                name={props.name} 
                value={value} 
                timeZone="Asia/Kolkata" 
                showTime={showTime} 
                minDate={minDate} 
                maxDate={maxDate} 
                placeholder={placeholder} 
                inputStyle={{ padding: "8px" }} 
                dateFormat={dateFormat} 
                onChange={(e) => handleOnChange(e)} 
                showIcon={showIcon} 
                disabled={disabled}
                hideOnDateTimeSelect
            />
            { props.errorMessage && <small className='p-error' style={{fontSize: 'x-small', marginTop: '0.25rem'}}>{props.errorMessage}</small> }
        </>
    )
    
    return (
        <PermDetailsWrapper
            displayComponent={renderCalenderField()}
            uniqueId={props.labelText}
            permissions={permissions}
            permittedCompanyRoleIds={permittedCompanyRoleIds}
            permittedExceptionUserRoleIds={permittedExceptionUserRoleIds}
            permittedExceptionNegitiveUserRoleIds={permittedExceptionNegitiveUserRoleIds}
            visible={!props.disabled && !isPermitted}
        />
    )
}

export default CalendarField